export const PROJECT_SAVE_REQUEST_EVENT = "critter-project-save-request";

export type ProjectSaveRequestTarget = "local-download" | "cloud" | "cloud-new";

export type ProjectSaveRequestDetail = {
  handled: boolean;
  target: ProjectSaveRequestTarget;
  resolve: (saved: boolean) => void;
};

export const requestProjectSave = (
  target: ProjectSaveRequestTarget = "local-download"
): Promise<boolean> => {
  if (typeof window === "undefined") return Promise.resolve(false);
  return new Promise((resolve) => {
    const detail: ProjectSaveRequestDetail = {
      handled: false,
      target,
      resolve,
    };
    window.dispatchEvent(new CustomEvent(PROJECT_SAVE_REQUEST_EVENT, { detail }));
    if (!detail.handled) resolve(false);
  });
};
